/**
 * Custom React hook to set a New Relic custom attribute (correlationId) on page load.
 *
 * This hook listens for the window 'load' event and, if a correlationId is present in sessionStorage,
 * sets it as a custom attribute in the New Relic browser agent for monitoring and tracing.
 *
 * Usage: Call this hook at the top level of your component to ensure correlationId is tracked in New Relic.
 */
import { useEffect } from 'react'

export function useNewRelicCustomAttribute() {
  useEffect(() => {
    const setNewRelicCustomAttribute = () => {
      const correlationId = sessionStorage.getItem('correlationId')
      if (correlationId) {
        // Set the correlationId in New Relic for distributed tracing/monitoring
        window?.newrelic?.setCustomAttribute('correlationId', correlationId)
      }
    }
    window.addEventListener('load', setNewRelicCustomAttribute)
    return () => {
      window.removeEventListener('load', setNewRelicCustomAttribute)
    }
  }, [])
}
